import { safeDeleteSheet } from "@/lib/office-helpers";

const ANDROID_APPS: Array<[string, number]> = [
  ["Facebook", 4119.0],
  ["Messenger", 3408.0],
  ["WhatsApp", 2979.0],
  ["Google Maps", 2488.0],
  ["Google Translate", 568.746],
  ["Instagram", 1843.0],
  ["Skype", 1039.0],
  ["Subway Surfers", 1025.0],
  ["Twitter", 833.858],
  ["Clean Master Antivirus", 833.739],
  ["Candy Crush Saga", 805.826],
  ["Snapchat", 782.837],
  ["SHAREit", 771.52],
  ["Facebook Lite", 731.282],
  ["Dropbox", 726.182],
  ["Line", 711.278],
  ["Viber", 680.635],
  ["Flipboard", 592.048],
  ["Super-Bright LED Flashlight", 587.693],
  ["My Talking Tom", 578.344],
  ["Security Master", 532.718],
];

export async function startProject17(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, "Descargas");

    const oldName = context.workbook.names.getItemOrNullObject("EncabezadoApp2");
    oldName.load("name");
    await context.sync();
    if (!oldName.isNullObject) {
      oldName.delete();
      await context.sync();
    }

    const sheet = context.workbook.worksheets.add("Descargas");

    sheet.getRange("A1:B2").merge();
    sheet.getRange("A1").values = [[
      "Las 20 aplicaciones de Android más populares en Google Play Store †",
    ]];
    sheet.getRange("A1").format.font.size = 18;
    sheet.getRange("A1").format.font.bold = true;
    sheet.getRange("A1").format.font.color = "#5B9BD5";
    sheet.getRange("A1").format.wrapText = true;

    sheet.getRange("E1:F2").merge();
    sheet.getRange("E1").values = [[
      "Las 20 aplicaciones de iOS más populares en la App Store",
    ]];
    sheet.getRange("E1").format.font.size = 16;
    sheet.getRange("E1").format.font.bold = true;
    sheet.getRange("E1").format.font.color = "#5B9BD5";
    sheet.getRange("E1").format.wrapText = true;

    sheet.getRange("A3:B3").values = [["Nombre", "Millones de descargas"]];
    sheet.getRange("E3:F3").values = [["Nombre", "Millones de descargas"]];
    sheet.getRange("A3:B3").format.font.bold = true;
    sheet.getRange("E3:F3").format.font.bold = true;

    sheet.getRange("A4:B24").values = ANDROID_APPS.map(([name, downloads]) => [
      name,
      downloads,
    ]);
    sheet.getRange("B4:B24").numberFormat = Array(ANDROID_APPS.length).fill([
      "0.000",
    ]);

    sheet.getRange("A27:B27").merge();
    sheet.getRange("A27").values = [[
      "† Esta lista no incluye aplicaciones que vienen precargadas en dispositivos Android de stock, como Google Play Services (5.959 mil millones), Gmail (3.945 mil millones), Google Maps (2.488 mil millones), Google News (2.341 mil millones) y YouTube (aproximadamente 5 mil millones).",
    ]];
    sheet.getRange("A27").format.wrapText = true;

    sheet.getRange("A:A").format.columnWidth = 180;
    sheet.getRange("B:B").format.columnWidth = 130;
    sheet.getRange("E:E").format.columnWidth = 180;
    sheet.getRange("F:F").format.columnWidth = 130;
    sheet.getRange("1:2").format.rowHeight = 48;

    sheet.pageLayout.leftMargin = 0.7;
    sheet.pageLayout.rightMargin = 0.7;
    sheet.pageLayout.topMargin = 0.75;
    sheet.pageLayout.bottomMargin = 0.75;
    sheet.pageLayout.headerMargin = 0.3;
    sheet.pageLayout.footerMargin = 0.3;
    sheet.pageLayout.orientation = Excel.PageOrientation.portrait;

    context.workbook.names.add("EncabezadoApp2", "=Descargas!$E$1:$F$3");

    sheet.activate();
    sheet.getRange("A1").select();

    await context.sync();
  });
}
